import {
  createUpdater,
  createReceiver,
  createSender,
} from '@/resource/resource'

import {
  prefixAPI,
} from '@/resource/api'

const MODEL = 'profile'

const PROFILE_DETAIL_LINK = prefixAPI('/detail/', MODEL)
const PROFILE_UPDATE_WHIT_PASS_LINK = prefixAPI('/update-with-pass/', MODEL)
const PROFILE_UPDATE_LINK = prefixAPI('/update/', MODEL)

const PROFILE_EMAIL_CHANGE_LINK = prefixAPI('/change-email/', MODEL)
const PROFILE_EMAIL_CONFIRM_LINK = prefixAPI('/confirm-email/confirm/', MODEL)
const PROFILE_EMAIL_CONFIRM_SEND_OTP_LINK = prefixAPI('/confirm-email/send-otp/', MODEL)

export const profileDetailResource = createReceiver(PROFILE_DETAIL_LINK)
export const profileUpdateWhitPass = createUpdater(PROFILE_UPDATE_WHIT_PASS_LINK)
export const profileUpdateResource = createUpdater(PROFILE_UPDATE_LINK)

export const emailChangeResource = createSender(PROFILE_EMAIL_CHANGE_LINK)
export const emailConfirmResource = createSender(PROFILE_EMAIL_CONFIRM_LINK)
export const emailSendOtpResource = createSender(PROFILE_EMAIL_CONFIRM_SEND_OTP_LINK)

